import { defineComponent, h } from 'vue';
import { QCard, QTabs, QTab, QTabPanels, QTabPanel } from 'quasar';
import BaseComponent from './baseFormMixin.jsx';
import utils from '../../../Shared/utils.jsx';

import TranslationContainer from './../TranslationContainer.jsx';
import FormFieldset from './formFieldset.jsx';

export default defineComponent({
    name: 'sform-tabs',
    mixins: [BaseComponent],
    components: {
        QCard,
        QTabs,
        QTab,
        QTabPanels,
        QTabPanel,
        TranslationContainer,
        FormFieldset,
    },
    data: () => ({
        selected_tab: 0,
        tabs_items: [],
        defaultTabexpn: null,
    }),
    props: {
    },
    created() {
        for (let tabi = 0; tabi < this.element.tabs.length; tabi++) {
            const tab = this.element.tabs[tabi];
            if (tab.title)
                tab.$$titleexpn = utils.compile(this, this.Translate(tab.title));
        }

        if (this.element.defaultTab)
            this.defaultTabexpn = utils.compile(this, this.element.defaultTab);
    },
    mounted() {
        if (this.defaultTabexpn) {
            const defaultTab = utils.evaluate(this.defaultTabexpn, this);
            const idx = this.element.tabs.findIndex(t => t.name == defaultTab);
            if (idx >= 0)
                this.selected_tab = idx;
        }
        this.loadComplete();
    },
    computed: {
        name: function () {
            return 'FormField_tabs';
        },
        SelectedTabIndex: function () {
            return this.selected_tab;
        },
    },
    methods: {
        getcondition(tab) {
            if (tab.condition && !tab.$$condition)
                tab.$$condition = utils.compileExpression(this, tab.condition);

            if (tab.$$condition)
                return utils.evaluate(tab.$$condition, this);
            else
                return true;
        },
        contentStartsWithOwnSpacing(items) {
            const firstItem = Array.isArray(items) ? items[0] : null;
            const type = firstItem?.type?.toLowerCase();

            if (type === 'fieldset' || type === 'tabs')
                return true;

            // These containers do not add visual spacing of their own.
            if (type === 'section' || type === 'conditional')
                return this.contentStartsWithOwnSpacing(firstItem.items);

            return false;
        },
    },
    render() {
        const tabs = [];
        const tab_body = [];

        for (let tabi = 0; tabi < this.element.tabs.length; tabi++) {
            const tab = this.element.tabs[tabi];
            const title = <TranslationContainer context={this} value={tab.title ? tab.title : null}></TranslationContainer>;
            const showTab = this.getcondition(tab);

            tabs.push(
                <QTab key={tabi} name={tabi} class="text-capitalize" style={showTab ? undefined : { display: 'none' }}>
                    {title}
                </QTab>
            );

            tab_body.push(
                <QTabPanel
                    key={tabi}
                    name={tabi}
                    style={{
                        // Longhand so App.vue can still set padding-bottom for hint fields
                        // (`padding: '32px 0 0'` would zero bottom via inline shorthand).
                        paddingTop: this.contentStartsWithOwnSpacing(tab.items) ? 0 : '32px',
                        paddingLeft: 0,
                        paddingRight: 0,
                        paddingBottom: 0,
                    }}
                >
                    <FormFieldset
                        root={this.root}
                        form={tab.items}
                        cmodel={this.cmodel}
                        modelkey={this.modelkey}
                        element={this.element}
                        noinput={this.noinput}
                        layouttype={this.layouttype}
                        appearance={this.appearance}
                        schema={this.schema}
                        scopeitems={this.scopeitems}
                        controlscope={this.controlscope}
                        depth={this.depth + 1}
                        isArrayItem={this.isArrayItem}
                        nestedInTitledFieldset={this.nestedInTitledFieldset}>
                    </FormFieldset>
                </QTabPanel>
            );
        }

        return (
            <QCard
                flat
                class={{ 'c-formTabs': true, [`c-name-${this.name || 'unnamed'}`]: true }}>
                <QTabs
                    indicatorColor="transparent"
                    align="left"
                    style={{ color: 'var(--v-secondaryText-base)' }}
                    dense
                    breakpoint={0}
                    modelValue={this.selected_tab}
                    onUpdate:modelValue={(index) => this.selected_tab = index}>
                    {tabs}
                </QTabs>

                <QTabPanels modelValue={this.selected_tab} onUpdate:modelValue={(index) => this.selected_tab = index}>
                    {tab_body}
                </QTabPanels>
            </QCard>
        );
    }
});